export const Popular_Cuisines = [
  {
    id: "600608",
    imageId: "rng/md/carousel/production/lbtzwnwla1pam1np4jtg",
  },
  {
    id: "600813",
    imageId: "rng/md/carousel/production/kmvbd3hyswd147u4qdn1",
  },
  {
    id: "600833",
    imageId: "rng/md/carousel/production/hvc4l0r0bgrtl6vdbbzv",
  },
  {
    id: "600868",
    imageId: "rng/md/carousel/production/oea45ipb1ctr4m61m7af",
  },
  {
    id: "600828",
    imageId: "rng/md/carousel/production/iwvt76wvh3a7dxmkljxd",
  },
  {
    id: "600901",
    imageId: "rng/md/carousel/production/vntl1lutut9bqsxjninx",
  },
  {
    id: "600916",
    imageId: "rng/md/carousel/production/wfzaxacltlxyi4shmm2u",
  },
  {
    id: "600932",
    imageId: "rng/md/carousel/production/hk7gdfeiwmy5nx6prv97",
  },
  {
    id: "601037",
    imageId: "rng/md/carousel/production/pa6ydsixfemhr7r9rjzc",
  },
];
export const carousel_Images = [
  {
    src: "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_520,h_520/rng/md/carousel/production/pneknawbadtvceqzwiep",
  },
  {
    src: "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_520,h_520/rng/md/carousel/production/dpqcjrxwruipnt1wyqnh",
  },
  {
    src: "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_520,h_520/rng/md/carousel/production/jmeoz6zu9fi0h9tw7xrb",
  },
  {
    src: "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_520,h_520/rng/md/carousel/production/lyn9at38gjithnogzfui",
  },
];
export const IMAGE_URL = 'https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320,c_fill/'
export const EMPTY_CART_IMG = 'https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_480/Cart_empty_-_menu_2x_ejjkf2'
export const MIN_ORDER_IMG = "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_210,h_398/4x_-_No_min_order_x0bxuf"
export const TRACK_ORDER_IMG = "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_224,h_412/4x_Live_order_zzotwy"
export const FAST_DEL_IMG = "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_248,h_376/4x_-_Super_fast_delivery_awv7sn"
export const SERVICES_IMG_CLASSNAME = "img-1 sm:w-[270px] sm:h-[333px] w-[100px] h-[180px] sm:flex sm:flex-col sm:items-center sm:justify-centre flex flex-col items-centre justify-centre"
export const LANDING_PAGE_IMG = "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,h_1340/Lunch1_vlksgq"
export const CITY_NAMES =['Delhi', 'Mumbai', ,'Bangalore', 'Kolkata', 'Hyderabad', 'Ahmedabad', 'Chennai', 'Pune', 'Jaipur',"Jammu", 'Surat','Srinagar',              'Lucknow', 'Nagpur', 'Visakhapatnam', 'Bhopal', 'Patna', 'Ludhiana', 'Agra', 'Nashik', 'Vadodara', 'Ghaziabad',              'Rajkot', 'Meerut', 'Amritsar', 'Varanasi', 'Aurangabad', 'Jabalpur', 'Gwalior', 'Vijayawada', 'Jodhpur','Mount Tabu','Patna','Bihar','Kanpur']
export const ABOUT_US = `Manik Sharma is an aspiring front-end developer who specializes in JavaScript and React. He has a passion for web development and a deep understanding of the latest technologies and trends in the industry. With a focus on user experience and accessibility, Manik brings creativity and technical expertise to every project he works on.

Manik has extensive experience in JavaScript, a versatile programming language that is widely used for front-end development. He has a strong understanding of the language's core concepts and is skilled in using JavaScript to create dynamic and interactive web experiences.

In addition to JavaScript, Manik also has expertise in React, a popular JavaScript library for building user interfaces. He has a deep understanding of React's component-based architecture and is skilled in using the library to build complex and scalable applications. He is familiar with the latest developments in React, including the use of Hooks and the development of reactive user interfaces.

Manik is committed to creating accessible and user-friendly web experiences. He understands the importance of accessibility for people with disabilities and is skilled in implementing accessibility features such as keyboard navigation and alternative text for images.

Manik is a proactive problem-solver and a dedicated team player. He is always striving to improve his skills and stay up-to-date with the latest developments in front-end development. He is driven by a passion for creating visually stunning


.`
export const ERROR_IMG = "https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/empty_404_3x_rgdw87"
export const TEXTS = [
  "Hungry",
  "Cooking Gone Wrong",
  "Movie marathon",
  "Game night",
  "Unexpected Guests",
];
export const STYLE = {
  modalOn: "Landing-Page w-full opacity-70",
  modalOff: "Landing-Page w-full",
};